module.exports = __webpack_public_path__ + "img/isa.b9d2daee.svg";